(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-blog-post"]) return;
  try {
    
  (function () {
    function initClock(root) {
      var pad = function (n) {
        return String(n).padStart(2, '0');
      };
      var weeks = ['日', '月', '火', '水', '木', '金', '土'];
      var tick = function () {
        var now = new Date();
        var set = function (sel, val) {
          root.querySelectorAll(sel).forEach(function (el) {
            el.textContent = val;
          });
        };
        set('.js-pp-year', now.getFullYear());
        set('.js-pp-month', now.getMonth() + 1);
        set('.js-pp-day', now.getDate());
        set('.js-pp-day-big', now.getDate());
        set('.js-pp-week', weeks[now.getDay()]);
        set('.js-pp-time', pad(now.getHours()) + ':' + pad(now.getMinutes()) + ':' + pad(now.getSeconds()));
      };
      tick();
      setInterval(tick, 1000);
    }

    function initCarousel(carousel) {
      var track = carousel.querySelector('.js-pp-track');
      var prev = carousel.querySelector('.js-pp-prev');
      var next = carousel.querySelector('.js-pp-next');
      var count = carousel.querySelector('.js-pp-count');
      if (!track || !prev || !next) return;

      var slideWidth = function () {
        var slide = track.querySelector('.pp-slide');
        return slide ? slide.getBoundingClientRect().width : track.clientWidth;
      };

      var update = function () {
        var pageWidth = track.clientWidth;
        if (!pageWidth) return;
        var pages = Math.max(1, Math.ceil((track.scrollWidth - 1) / pageWidth));
        var current = Math.min(pages, Math.round(track.scrollLeft / pageWidth) + 1);
        if (count) count.textContent = current + '/' + pages;
        prev.disabled = track.scrollLeft <= 0;
        next.disabled = track.scrollLeft + pageWidth >= track.scrollWidth - 1;
      };

      /* Scroll one page, landing exactly on a slide boundary so that
         scroll-snap does not cancel the smooth programmatic scroll. */
      var goTo = function (dir) {
        var sw = slideWidth();
        if (!sw) return;
        var perPage = Math.max(1, Math.round(track.clientWidth / sw));
        var currentIndex = Math.round(track.scrollLeft / sw);
        var target = (currentIndex + dir * perPage) * sw;
        target = Math.max(0, Math.min(target, track.scrollWidth - track.clientWidth));
        track.scrollTo({ left: target, behavior: 'smooth' });
        setTimeout(update, 600);
      };

      prev.addEventListener('click', function () {
        goTo(-1);
      });
      next.addEventListener('click', function () {
        goTo(1);
      });
      track.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);
      update();
    }

    function init() {
      document.querySelectorAll('.pp-single').forEach(function (root) {
        if (root.dataset.ppInit) return;
        root.dataset.ppInit = 'true';
        initClock(root);
        root.querySelectorAll('.js-pp-carousel').forEach(initCarousel);
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
    document.addEventListener('shopify:section:load', init);
  })();

  } catch(e) { console.error(e); }
})();
})();
